import {
  OccupationAreaItem,
  RecordLike,
  SelectOption,
} from "./networkFormTypes";

type PlanOptionSource = {
  title: string;
  codYear: string | number;
};

export const ALL_DISTRICTS_OPTION: SelectOption = {
  label: "TODOS OS BAIRROS",
  value: "TODOS",
};

export const ALL_OCCUPATION_AREAS_OPTION: SelectOption = {
  label: "TODAS AS ÁREAS",
  value: "TODOS",
};

export const selectParsePlan = (
  data?: PlanOptionSource[] | null
): SelectOption[] => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  return data.map((item) => ({
    label: item.title,
    value: String(item.codYear),
  }));
};

export const parseSelectData = (
  data?: RecordLike | null,
  includeAllDistricts = false
): SelectOption[] => {
  const options: SelectOption[] = includeAllDistricts
    ? [ALL_DISTRICTS_OPTION]
    : [];

  if (!data) {
    return options;
  }

  Object.values(data).forEach((value) => {
    options.push({
      label: String(value),
      value: String(value),
    });
  });

  return options;
};

export const parseOccupationAreaData = (
  data?: OccupationAreaItem[] | null
): SelectOption[] => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  return [
    ALL_OCCUPATION_AREAS_OPTION,
    ...data.map((item) => ({
      label: item.descricao,
      value: item.codigo_area_atuacao,
    })),
  ];
};

export const normalizeSelectedValue = (value: string): string => {
  return value !== "TODOS" ? value : "";
};